export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 398.125c34.667-103.59 140.667-174.486 318-212.689C495.333 147.232 610 68.738 662-1.056v399.181H0z\" fill=\"#EBF5FB\"/>",
  "attrs": {
    "width": "662",
    "height": "245",
    "viewBox": "0 0 662 245",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};